var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Base",
    d: "M18.5459 3.81783L3.81867 18.5451C3.3668 18.997 3.3668 19.7296 3.81867 20.1815C4.27053 20.6333 5.00315 20.6333 5.45502 20.1815L20.1822 5.45419C20.6341 5.00232 20.6341 4.2697 20.1822 3.81783C19.7304 3.36596 18.9977 3.36596 18.5459 3.81783Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Base_2",
    d: "M20.1816 18.5455L5.45441 3.81818C5.00254 3.36631 4.26992 3.36631 3.81805 3.81818C3.36619 4.27005 3.36619 5.00268 3.81805 5.45454L18.5453 20.1818C18.9971 20.6337 19.7297 20.6337 20.1816 20.1818C20.6335 19.7299 20.6335 18.9973 20.1816 18.5455Z",
    fill: "#51566D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.547fe3769c700be6a9629a33762bd40c.svg";
export { ForwardRef as ReactComponent };